import { AiOutlineHeart, AiOutlineUser } from "react-icons/ai"
import { HiOutlineShoppingBag } from "react-icons/hi"
import { Link } from "react-router-dom"
import useCartContext from "../context/CartContext"
import useGlobalContext from "../context/GlobalContext"
import Cart from "./Cart"
import WishList from "./WishList"

const Header = () => {
  const { cartQuantity } = useCartContext()
  const { small, setShowMenu, showMenu, setOpenCart, setOpenWishList } =
    useGlobalContext()

  return (
    <header className={`header ${small ? "scrolled" : ""}`}>
      <Cart />
      <WishList />
      <nav>
        <ul className="no-mobile">
          <li>
            <Link to="/">shop</Link>{" "}
          </li>
          <li>
            <Link to="/">culture</Link>
          </li>
          <li>
            <Link to="/">about</Link>
          </li>
        </ul>
        <div className="logo">
          <h1>
            <Link to="/">dallol</Link>
          </h1>
        </div>
        <ul>
          <li className="link-icon no-mobile" tabIndex={1} aria-label="Account">
            <AiOutlineUser className="hd-icon" />
          </li>
          <li
            className="cart-icon link-icon"
            data-property-amount="0"
            tabIndex={1}
            aria-label="Wishlist"
            onClick={() => setOpenWishList(true)}
          >
            <AiOutlineHeart className="hd-icon" />
          </li>
          <li
            className="cart-icon link-icon"
            data-property-amount={cartQuantity}
            tabIndex={1}
            aria-label="Cart"
            onClick={() => setOpenCart(true)}
          >
            <HiOutlineShoppingBag className="hd-icon" />
          </li>
          <li
            onClick={() => setShowMenu((prev) => !prev)}
            aria-label="Menu"
            className={`menu-icon ${showMenu ? "show" : ""}`}
            tabIndex={1}
          >
            <span></span>
            <div className="flexed">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span></span>
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default Header
